import { GetterTree } from 'vuex';
import { PartyState, Party, PartyCommentPaginator, PartyContactPaginator } from './types';
import { RootState, Attachment } from '@/types';

export const getters: GetterTree<PartyState, RootState> = {
    party(state): Party | undefined {
        const party  = state.data.party || undefined;
        return party;
    },
    comments(state): PartyCommentPaginator | undefined {
        const comments = state.data.comments || undefined;
        return comments;
    },
    attachments(state): Attachment[] | undefined {
        const attachments = state.data.attachments || undefined;
        return attachments;
    },
    contacts(state): PartyContactPaginator | undefined {
        const contacts = state.data.contacts || undefined;
        return contacts;
    },
};
